/* eslint sort-keys: "error" */
export default {
  /* german */
  de: {
    'access_rights': 'Zugriffsrechte',
    'address_information': 'Anschrift',
    'cancel_subscription': 'Kündigen',
    'confirm_payment_body': 'Bitte bestätige deine Zahlung an likvi in Höhe von {amount}.',
    'confirm_payment_title': 'Zahlung bestätigen',
    'confirm_subscription': 'Kostenpflichtig abonnieren',
    'confirm_team_delete_body': 'Möchtest du die Firma "{team}" wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden!',
    'confirm_team_delete_title': 'Firma löschen?',
    'confirm_user_delete_body': 'Möchtest du {user} wirklich aus {team} entfernen?',
    'confirm_user_delete_title': 'Benutzer entfernen?',
    'confirm_user_promote_body': '{user} wird zum neuen Hauptadministrator für {team}. Du verlierst alle damit verbundenen Berechtigungen.',
    'confirm_user_promote_title': 'Hauptadministrator wechseln?',
    'contact_information': 'Kontaktinformationen',
    'copy_link': 'Link kopieren',
    'coupon': 'Gutschein',
    'coupon_invalid': 'Der Gutschein ist ungültig',
    'credit_card_hint': 'Wir untersützen alle gängigen Marken wie MasterCard, Visa, etc.',
    'credit_card_holder': 'Kreditkarteninhaber',
    'delete_team': 'Firma löschen',
    'delete_team_hint': 'Wenn du die Löschung deiner Firma beantragst, wird deine Firma inklusive aller Kundendaten, Rechnungen, etc. nach <strong>7 Tagen</strong> gelöscht.<br><br> Innerhalb dieses Zeitraums kannst du diese Firma bereits nicht mehr nutzen, es kann aber durch den Support wiederhergestellt werden.<br> Eine Wiederherstellung deiner Daten ist nach 7 Tagen nicht mehr möglich. Bevor deine Firma endgültig löschst, solltest du ein Backup deiner Daten erstellen.',
    'direct_debit_hint': 'Wir unterstützen alle Koten im SEPA-Raum.',
    'direct_debit_mandate': 'Ich ermächtige die codelayer GmbH und Stripe, unserem Zahlungsdienstleister, Zahlungen von meinem Konto mittels Lastschrift einzuziehen. Zugleich weise ich mein Kreditinstitut an, die von Codelayer UG (haftungsbeschränkt) und Stripe auf mein Konto gezogenen Lastschriften einzulösen. Hinweis: Ich kann innerhalb von acht Wochen, beginnend mit dem Belastungsdatum, die Erstattung des belasteten Betrages verlangen. Es gelten dabei die mit meinem vereinbarten Bedingungen.',
    'import_invoice_hint': 'Du kannst deine existierenden Rechnungen als PDF hochladen und als Rechnung in likvi hinterlegen.',
    'import_invoices_label': 'Rechnungen importieren',
    'invite': 'Einladung | Einladungen',
    'invite_accepted': 'Du wurdest der Firma hinzugefügt.',
    'invite_created': 'Nutzer wurde eingeladen',
    'invite_more': 'Weitere Mitglieder hinzufügen',
    'invite_removed': 'Einladung wurde erfolgreich entfernt',
    'invite_text': 'Du wurdest eingeladen {team} beizutreten',
    'invited': 'Eingeladen',
    'leave_team': 'Firma verlassen',
    'leave_team_cancel': 'Abbrechen',
    'leave_team_message': 'Willst du die Firma {team} wirklich verlassen?',
    'leave_team_ok': 'Verlassen',
    'legal_forms': {
      'corporation': {
        'subtitle': 'GmbH, UG, AG',
        'title': 'Kapitalgesellschaft'
      },
      'freelancer': {
        'subtitle': 'nach §18 EStG.',
        'title': 'Freiberufler*in'
      },
      'other': {
        'subtitle': '',
        'title': 'Andere Rechtsform'
      },
      'partnership': {
        'subtitle': 'GbR, oHG, KG oder Einzelunternehmen',
        'title': 'Personengesellschaft'
      },
      'sole': {
        'subtitle': '',
        'title': 'Einzelunternehmer*in'
      }
    },
    'legal_information': 'Rechtliche Informationen',
    'managers': 'Geschäftsführer',
    'member_count': 'Deine Firma hat aktuell',
    'new_invite_title': 'Nutzer zu {team} einladen',
    'new_team': 'Firma anlegen',
    'new_team_stepper': {
      'step_1': {
        'subtitle': 'Wähle die Rechtsform deines Unternehmens aus',
        'title': 'Erstelle eine neue Firma'
      },
      'step_2': {
        'subtitle': 'Nutzt du die Kleinunternehmerregelung nach §19 UStG.?',
        'title': 'Kleinunternehmerregelung'
      },
      'step_3': {
        'subtitle': 'Verrate uns noch ein paar Daten zu deinem Unternehmen',
        'title': 'Fast geschafft!'
      }
    },
    'no_invites': 'Es wurden keine weiteren Mitglieder eingeladen',
    'no_pdf_template': 'Kein Briefpapier hinterlegt.',
    'no_small_business': 'Kein Kleinunternehmen',
    'no_teams': 'Du bist aktuell kein Mitglied einer Firma!',
    'payment_already_confirmed_body': 'Die Zahlung wurde bereits bestätigt. Es ist keine weitere Aktion nötig.',
    'payment_already_confirmed_title': 'Zahlung bereits bestätigt',
    'payment_canceled_body': 'Die Zahlung wurde storniert. Bitte kontaktiere unseren Support oder aktualisiere deine Zahlungsinformationen.',
    'payment_canceled_title': 'Zahlung storniert',
    'payment_confirmation': 'Zahlungsbestätigung',
    'payment_confirmation_failed': 'Die Zahlungsbestätigung ist fehlgeschlagen. Bitte versuche es erneut oder kontaktiere unseren Support.',
    'payment_confirmation_message': 'Bitte überprüfe zuletzt noch dein ausgewähltes Abonnement. Du hast nun auch die Möglichkeit deinen Gutschein einzulösen.',
    'payment_confirmed_body': 'Die Zahlung wurde erfolgreich bestätigt. Du kannst das Fenster nun schließen.',
    'payment_confirmed_title': 'Zahlung bestätigt',
    'payment_details': 'Zahlungsinformationen',
    'payment_details_message': 'Bitte fülle die Zahlungsinformationen aus.',
    'payment_invalid_body': 'Bitte kontaktiere unseren Support um das Problem zu beheben.',
    'payment_invalid_title': 'Zahlung ungültig',
    'payment_method': 'Zahlungsmethode',
    'payment_method_message': 'Wähle deine gewünschte Zahlungsmethode aus. Solltest du einen Gutschein haben, kannst du diesen im letzten Schritt einlösen.',
    'payment_period': 'Zahlungsweise',
    'pdf_hidden_sections': 'Ausgeblendete Bereiche der PDF',
    'pdf_hidden_sections_address': 'Adresse',
    'pdf_hidden_sections_address_notes': 'Adressnotizen',
    'pdf_hidden_sections_content': 'Inhalt',
    'pdf_hidden_sections_footer': 'Fußzeile',
    'pdf_hidden_sections_header': 'Kopfzeile',
    'pdf_hidden_sections_hint': 'Hier kannst du festlegen, welche Bereiche in der generierten PDF sichtbar sein sollen.<br>Klicke einfach auf die Bereiche, welche du ausblenden möchtest.',
    'pdf_hidden_sections_invoice_meta': 'Rechnungsinformationen',
    'pdf_hidden_sections_return_address': 'Rücksendeadresse',
    'pdf_template': 'Briefpapier',
    'pdf_template_delete_button': 'Briefpapier löschen',
    'pdf_template_delete_complete': 'Dein Briefpapier wurde gelöscht',
    'pdf_template_hint': 'Lade dein Briefpapier hoch, um es für deine Rechnungen zu benutzen.<br>Änderungen am Briefpapier haben nur Einfluss auf zukünftige Rechnungen.',
    'pdf_template_upload_complete': 'Dein Briefpapier wurde hochgeladen',
    'permission_updated': 'Berechtigungen wurden erfolgreich aktualisiert',
    'resume_subscription': 'Abonnement fortsetzen',
    'role': 'Berechtigung',
    'role_0': 'Hauptadministrator',
    'role_1': 'Administrator',
    'role_2': 'Nutzer',
    'role_3': 'Nur lesen',
    'send_invite': 'Einladung versenden',
    'small_business': 'Kleinunternehmen',
    'small_business_info': 'Das Unternehmen fällt unter die Kleinunternehmerregelung nach §19 UStG.',
    'small_business_info_student': 'Da du den Studenten Tarif nutzt, kannst du diese Option nicht ändern.',
    'subscribe': 'Abonnieren',
    'subscription': 'Abonnement',
    'subscription_canceled': 'Dein Abonnement wurde gekündigt und endet am {endsAt}.',
    'subscription_successful_body': 'Dein Abonnement wurde erfolgreich abgeschlossen',
    'subscription_successful_title': 'Vielen Dank!',
    'subscriptions_moved': 'Die Verwaltung deines Abonnements ist nur noch in der neuen Version von likvi verfügbar. Dort kannst du deine Rechnungen einsehen oder dein Abonnement aktualisieren.',
    'swap_subscription': 'Abonnement wechseln',
    'team': 'Firma | Firmen',
    'team_created': 'Die neue Firma wurde erfolgreich angelegt',
    'team_deleted': 'Bitte überprüfe dein E-Mail Postfach und bestätige die Löschung.',
    'team_deleted_confirmation_body': 'Du wirst in 5 Sekunden automatisch weitergeleitet.',
    'team_deleted_confirmation_title': 'Firma wurde gelöscht',
    'team_details': 'Firmeninformationen',
    'team_name': 'Firmenname',
    'team_not_empty': 'Es darf nur noch ein Mitglied in einer Firma geben wenn diese gelöscht werden soll',
    'team_setting': 'Firmen Einstellungen',
    'token': 'Token',
    'update_subscription': 'Zahlungsinformationen ändern',
    'user': 'Benutzer',
    'user_removed': 'Benutzer wurde erfolgreich entfernt'
  },

  /* english */
  en: {
    'access_rights': 'Access Rights',
    'address_information': 'Address',
    'cancel_subscription': 'Cancel Subscription',
    'confirm_payment_body': 'Please confirm your payment to likvi of {amount}.',
    'confirm_payment_title': 'Confirm Payment',
    'confirm_subscription': 'Subscribe',
    'confirm_team_delete_body': 'Do you really want to delete the company "{team}"? This can not be undone!',
    'confirm_team_delete_title': 'Delete company?',
    'confirm_user_delete_body': 'Do you really want to remove {user} from {team}?',
    'confirm_user_delete_title': 'Remove user?',
    'confirm_user_promote_body': '{user} will be the new primary owner for {team} and you will loose the corresponding rights.',
    'confirm_user_promote_title': 'Change primary owner?',
    'contact_information': 'Contact Information',
    'copy_link': 'Copy Link',
    'coupon': 'Coupon',
    'coupon_invalid': 'The coupon code is invalid',
    'credit_card_hint': 'We support all major brands such as MasterCard, Visa, etc.',
    'credit_card_holder': 'Credit Card Holder',
    'delete_team': 'Delete company',
    'delete_team_hint': 'Your company, including all customer data, invoices, etc. will be removed <strong>7 days</strong> after requesting the deletion.<br><br> Within this period, you will not be able to use your company anymore, however, your team may be restored by the support team if you file an according request.<br> We will no longer be able to restore your data once 7 days have passed. Please make sure to backup your data before you decide to delete your company.',
    'direct_debit_hint': 'We support all SEPA bank accounts.',
    'direct_debit_mandate': 'By providing your IBAN and confirming this payment, you are authorizing codelayer GmbH and Stripe, our payment service provider, to send instructions to your bank to debit your account and your bank to debit your account in accordance with those instructions. You are entitled to a refund from your bank under the terms and conditions of your agreement with your bank. A refund must be claimed within 8 weeks starting from the date on which your account was debited.',
    'import_invoice_hint': 'You can upload your existing invoices as PDF and store them as invoices in likvi.',
    'import_invoices_label': 'Import invoices',
    'invite': 'Invite | Invites',
    'invite_accepted': 'You have been added to the company.',
    'invite_created': 'Invite was sent to user',
    'invite_more': 'Invite More Members',
    'invite_removed': 'Invite was successfully removed',
    'invite_text': 'You have been invited to join {team}',
    'invited': 'Invited',
    'leave_team': 'Leave company',
    'leave_team_cancel': 'Abort',
    'leave_team_message': 'Do you really want to leave the company {team}? This can not be undone!',
    'leave_team_ok': 'Leave now',
    'legal_forms': {
      'corporation': {
        'subtitle': 'GmbH, UG, AG',
        'title': 'Corporation'
      },
      'freelancer': {
        'subtitle': 'according to §18 EStG.',
        'title': 'Freelancer'
      },
      'other': {
        'subtitle': '',
        'title': 'Other Legal Form'
      },
      'partnership': {
        'subtitle': 'GbR, oHG, KG or Sole Proprietorship',
        'title': 'Partnership'
      },
      'sole': {
        'subtitle': '',
        'title': 'Sole Entrepreneur'
      }
    },
    'legal_information': 'Legal Information',
    'managers': 'CEOs',
    'member_count': 'Your company currently has',
    'new_invite_title': 'Invite user to {team}',
    'new_team': 'Create a new company',
    'new_team_stepper': {
      'step_1': {
        'subtitle': 'Choose the legal form of your company',
        'title': 'Create A New Company'
      },
      'step_2': {
        'subtitle': 'Does §19 UStG. apply to your company?',
        'title': 'Small Company Regulation'
      },
      'step_3': {
        'subtitle': 'Tell us a few more details about your company',
        'title': 'Almost Done!'
      }
    },
    'no_invites': 'You are the only member of the company',
    'no_pdf_template': 'No letter paper uploaded.',
    'no_small_business': 'No Small Business',
    'no_teams': 'You are currently not a member of any company!',
    'payment_already_confirmed_body': 'The payment has already been confirmed. No further action is required.',
    'payment_already_confirmed_title': 'Payment already Confirmed',
    'payment_canceled_body': 'The payment was canceled. Please contact our support or update your payment details.',
    'payment_canceled_title': 'Payment Canceled',
    'payment_confirmation': 'Payment Confirmation',
    'payment_confirmation_failed': 'The payment confirmation failed. Please try again or contact our support.',
    'payment_confirmation_message': 'Please review your select plan. You can also redeem your coupon now.',
    'payment_confirmed_body': 'The payment has successfully been confirmed. You can now close this window.',
    'payment_confirmed_title': 'Payment Confirmed',
    'payment_details': 'Payment Information',
    'payment_details_message': 'Please enter your payment information below.',
    'payment_invalid_body': 'Please contact our support to resolve the issue.',
    'payment_invalid_title': 'Payment Invalid',
    'payment_method': 'Payment Method',
    'payment_method_message': 'Please select your preferred payment method. You can redeem your coupon in the last step.',
    'payment_period': 'Payment Period',
    'pdf_hidden_sections': 'Hidden PDF sections',
    'pdf_hidden_sections_address': 'Address',
    'pdf_hidden_sections_address_notes': 'Address notes',
    'pdf_hidden_sections_content': 'Content',
    'pdf_hidden_sections_footer': 'Footer',
    'pdf_hidden_sections_header': 'Header',
    'pdf_hidden_sections_hint': 'Here you can set which section should be visible in the generated PDF.<br>Simply klick on the sections you want to hide.',
    'pdf_hidden_sections_invoice_meta': 'Invoice meta information',
    'pdf_hidden_sections_return_address': 'Return address',
    'pdf_template': 'Letter paper',
    'pdf_template_delete_button': 'Delete letter paper',
    'pdf_template_delete_complete': 'Your letter paper has been deleted',
    'pdf_template_hint': 'Upload your letter paper to use it for your invoices.<br>Changes to your letter paper will only affect future invoices.',
    'pdf_template_upload_complete': 'Your letter paper has been uploaded',
    'permission_updated': 'Permissions were successfully updated',
    'resume_subscription': 'Resume Subscription',
    'role': 'Permission',
    'role_0': 'Primary owner',
    'role_1': 'Admin',
    'role_2': 'User',
    'role_3': 'Read-only',
    'send_invite': 'Send Invite',
    'small_business': 'Small Business',
    'small_business_info': 'Small business operator regulations (§19 UStG.) apply for this company. German businesses only.',
    'small_business_info_student': 'This option can not be changed since you are on the student plan.',
    'subscribe': 'Subscribe',
    'subscription': 'Subscription',
    'subscription_canceled': 'Your subscription has been canceled and will end at {endsAt}.',
    'subscription_successful_body': 'You have successfully been subscribed to the selected plan',
    'subscription_successful_title': 'Thank You!',
    'subscriptions_moved': 'The management of your subscription is only available in the new version of likvi. There you can view your invoices or update your subscription.',
    'swap_subscription': 'Change Subscription',
    'team': 'Company | Companies',
    'team_created': 'New company created successfully',
    'team_deleted': 'Please check your E-Mail inbox and confirm the deletion.',
    'team_deleted_confirmation_body': 'You will be redirected to the login page in 5 seconds.',
    'team_deleted_confirmation_title': 'Company has been deleted',
    'team_details': 'Company Details',
    'team_name': 'Company Name',
    'team_not_empty': 'You have to be the last member of this company to delete it',
    'team_setting': 'Company settings',
    'token': 'Token',
    'update_subscription': 'Update Payment Information',
    'user': 'User | Users',
    'user_removed': 'User was successfully removed'
  }
}
